var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  dataSchemaToTSDeclaration: () => dataSchemaToTSDeclaration
});
module.exports = __toCommonJS(stdin_exports);
var import_getPatchedDataSchema = require("../getPatchedDataSchema");
let globalCounter = 0;
const goodIdRegex = /^[a-zA-Z_]\w+$/;
function getNextUUID(prefix) {
  return prefix + (globalCounter += 1);
}
function makeUUIDForSchema(x, fallbackPrefix = "AnonymousSchema") {
  let prefix = x && typeof x.id === "string" && goodIdRegex.test(x.id) ? x.id : fallbackPrefix;
  prefix = prefix[0].toUpperCase() + prefix.substring(1);
  return getNextUUID(prefix);
}
class Instance {
  constructor(schema) {
    this.initialized = false;
    this.dependencies = /* @__PURE__ */ new Set();
    this.declStyle = "type";
    this.schema = schema;
    this.id = makeUUIDForSchema(schema);
    if (schema.type === "object")
      this.declStyle = "interface";
  }
  toTSDeclaration(ctxOpts) {
    const { id, schema, declStyle } = this;
    return [declStyle === "type" ? `type ${id} = ` : `interface ${id} `, ds2type(schema, ctxOpts)].join("");
  }
  toJSDoc() {
    return wrapAsJSDoc(toComment(this.schema));
  }
}
const cache = /* @__PURE__ */ new WeakMap();
function getInstance(schema) {
  let last = cache.get(schema);
  if (!last) {
    last = new Instance(schema);
    cache.set(schema, last);
  }
  return last;
}
function resolveRef(s) {
  while ((0, import_getPatchedDataSchema.isPatchedDataSchema)(s) && s.$isIdenticalToRef)
    s = s.$isIdenticalToRef;
  return s;
}
function dataSchemaToTSDeclaration(schema, _opts) {
  const opts = Object.assign({ typePrefix: "" }, _opts);
  const visited = /* @__PURE__ */ new Set();
  const declarations = [];
  const ctxOpts = {
    getNestedType(schema2) {
      schema2 = resolveRef(schema2);
      if (schema2.type === "object") {
        queue.push(schema2);
        return getInstance(schema2).id;
      }
      return ds2type(schema2, ctxOpts);
    }
  };
  const queue = [schema];
  while (queue.length) {
    const s = resolveRef(queue.shift());
    if (visited.has(s))
      continue;
    visited.add(s);
    const inst = getInstance(s);
    const doc = toComment(s);
    const declarationCode = inst.toTSDeclaration(ctxOpts);
    declarations.push({
      schema: s,
      declarationCode,
      doc,
      typeId: inst.id,
      get code() {
        return wrapAsJSDoc(doc) + opts.typePrefix + declarationCode;
      }
    });
  }
  const getFullCode = () => declarations.map((x) => x.code).join("\n\n");
  return {
    declarations,
    exportedTypeId: getInstance(schema).id,
    getFullCode,
    toString: getFullCode
  };
}
function ds2type(schema, opts) {
  const { type, tsType, fields = [], items, methods = [], enum: enumList } = schema;
  if (tsType)
    return tsType;
  if (Array.isArray(enumList) && enumList.length) {
    return enumList.map((item) => {
      try {
        return JSON.stringify(item.value);
      } catch (error) {
        return null;
      }
    }).filter(Boolean).join(" | ");
  }
  switch (type) {
    case "string":
    case "number":
    case "boolean":
      return type;
    case "integer":
      return "number";
    case "object": {
      const lines = [
        ...fields.map((f) => `${wrapAsJSDoc(toComment(f))}${escapeId(f.id)}: ${opts.getNestedType(f)};`),
        ...methods.map((m) => `${wrapAsJSDoc(toComment(m))}${ms2type(escapeId(m.id), m, opts)};`)
      ];
      if (!lines.length)
        return "{}";
      return `{
${lines.join("\n").replace(/^/gm, "  ")}
}`;
    }
    case "array":
      if (!items)
        return "Array<any>";
      return `Array<${opts.getNestedType(items)}>`;
    case "any":
    case "null":
    default:
      return "any";
  }
}
function escapeId(id) {
  if (typeof id === "string" && goodIdRegex.test(id))
    return id;
  return JSON.stringify(`${id || "unknown"}`);
}
function toComment(schema, opt = {}) {
  const content = [];
  if (schema.title)
    content.push(schema.title);
  if (schema.description)
    content.push(schema.description);
  if (schema.default)
    content.push(`@default
${JSON.stringify(schema.default, null, 2)}`);
  if (schema.arguments)
    content.push(...schema.arguments.map((arg) => `@param ${arg.id} - ${toComment(arg, { noDsTitle: true })}`));
  if (schema.returnValue)
    content.push(`@returns - ${toComment(schema.returnValue, { noDsTitle: true })}`);
  if (opt.extraContent)
    content.push(opt.extraContent);
  if (!opt.noDsTitle && schema.title)
    content.push(`@dsTitle ${schema.title}`);
  const ans = content.join("\n").trim();
  return ans;
}
function wrapAsJSDoc(content) {
  content = content.trim();
  if (!content)
    return "";
  if (!content.includes("\n"))
    return `/** ${content} */
`;
  return `/**
${content.replace(/^/gm, " * ")}
 */
`;
}
function ms2type(leading, method, opts) {
  var _a;
  if (method.tsType) {
    const lines = method.tsType.split("\n").filter(Boolean);
    const combined = lines.length > 1 ? lines.map((x) => `(${x})`).join(" | ") : lines[0];
    return `${leading}: ${combined}`;
  }
  const args = ((_a = method.arguments) === null || _a === void 0 ? void 0 : _a.map((item, index) => `${item.id || `_arg${index}`}: ${opts.getNestedType(item)}`)) || [];
  const argString = args.join(", ");
  const returnType = method.returnValue ? opts.getNestedType(method.returnValue) : "any";
  const returnTypeString = method.isAsync ? `Promise<${returnType}>` : returnType;
  return `${leading}(${argString}): ${returnTypeString}`;
}
